import React, { FC } from 'react'
import Page from 'modules/common/Page'
import ActiveDirectoryPageContent from 'modules/auth/ActiveDirectoryPageContent'

const ActiveDirectoryPage: FC = () => (
	<Page layout={'side'} guard titleKey="adLogin">
		<ActiveDirectoryPageContent />
	</Page>
)

export default ActiveDirectoryPage
